import { useNuxtApp } from '#imports'

// Craft `uri` = the frontend path without the locale prefix; no uri = a section without pages
export const entryPath = entry => entry?.uri
  ? useNuxtApp().$localePath(entry.uri === '__home__' ? '/' : `/${entry.uri}`)
  : null

// What a CMS Link field renders: a route, an href with the CMS target, or nothing (no destination).
// Form links are rendered by the components that handle forms (Paragraphs anchors, Accordion, hero modal).
export const linkAttrs = link => {
  if (!link) return null
  if (link.type === 'entry') {
    const to = entryPath(link.entry)
    return to ? { to } : null
  }
  if (link.type === 'form') return null
  const href = link.url || link.document?.src
  return href ? { href, target: link.target || '_self' } : null
}

export const delocalize = routeName => routeName && routeName?.split('___')[0]
export const routeLocale = routeName => routeName && routeName?.split('___')[1]
